import { gql } from '@apollo/client';

export const UPDATE_EVENT_START_DATETIME = gql`
    subscription updateEventStartDatetime($eventId: Int!) {
        updateEventStartDatetime(eventId: $eventId)
    }
`;
